import { render, staticRenderFns } from "./FileMimeType.vue?vue&type=template&id=6608bf7c&scoped=true"
import script from "./FileMimeType.vue?vue&type=script&lang=js"
export * from "./FileMimeType.vue?vue&type=script&lang=js"
import style0 from "./FileMimeType.vue?vue&type=style&index=0&id=6608bf7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608bf7c",
  null
  
)

export default component.exports